<ion-app>
    <ion-menu side="start" menu-id="navigation" content-id="main-content">
        <app-main-menu></app-main-menu>
    </ion-menu>

    <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
